import { FC } from 'react';
import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { FormControlLabel } from '../../uiLibraryImports';
import globalColors from '../globalColors';

const Toggle: FC<{ defaultValue: boolean; onChange: Function; label?: string; size?: string; disable?: boolean }> = ({
    defaultValue,
    onChange,
    label = '',
    size = 'medium',
    disable
}: {
    defaultValue: boolean;
    onChange: Function;
    label?: string;
    size?: string;
    disable?: boolean;
}) => {
    const IOSSwitch = styled((props: SwitchProps) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: size == 'small' ? '27px !important' : '50px !important',
        height: size == 'small' ? '15px !important' : '26px !important',
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: '0px !important',
            margin: size == 'small' ? '2.5px !important' : '2px !important',
            backgroundColor: 'transparent !important',
            position: 'absolute !important',
            color: '#fff !important',
            transitionDuration: '300ms !important',
            '&.Mui-checked': {
                transform: size == 'small' ? 'translateX(13px) !important' : 'translateX(22px) !important',
                color: '#fff !important',
                '& + .MuiSwitch-track': {
                    width: size == 'small' ? '30px !important' : '50px !important',
                    backgroundColor: `${globalColors.backgrounds.darkPurple} !important`,
                    opacity: '1 !important',
                    border: '0px !important'
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: '0.5 !important'
                }
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d !important',
                border: '6px solid #fff !important'
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
            }
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box !important',
            width: size == 'small' ? '10px !important' : '22px !important',
            height: size == 'small' ? '10px !important' : '22px !important'
        },
        '& .MuiSwitch-track': {
            borderRadius: '13px !important',
            width: size == 'small' ? '34px !important' : '50px !important',
            backgroundColor: `${globalColors.backgrounds.medPurple} !important`,
            opacity: '1 !important',
            transition: theme.transitions.create(['background-color'], {
                duration: 500
            })
        }
    }));

    return (
        <FormControlLabel
            control={
                <IOSSwitch sx={{ m: 1 }} defaultChecked={defaultValue} onChange={onChange as any} disabled={disable} />
            }
            label={label}
        />
    );
};

export default Toggle;
